import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/Template.css"
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class Message extends Component {
  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div>
        { this.props.message.outbound == false &&
          <div>
            <li className="message">{this.props.message.message}</li>
            <p id="rightAlignedTimestamp">{this.props.message.friendly_time}</p>
          </div>
        }
        { this.props.message.outbound == true &&
          <div>
            <div className="adminMessageBlock">
              <p>Spiffy:</p>
              <li className="messageAdmin">{this.props.message.message}</li>
            </div>
            <p className="timestamp">{this.props.message.friendly_time}</p>
          </div>
        }
      </div>
    )
  }
}
export default Message



// WEBPACK FOOTER //
// ./src/Components/Message.js